import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import PlaceReviewItem from '@/components/PlaceReviewItem';
export default function PlaceDetailPlaceReviewItem({ placeId, review, }) {
    return _jsx(PlaceReviewItem, { placeId: placeId, review: review, variant: "detail" });
}
